import { certificateIcon, deadlineIcon, liveIcon, menuBookIcon, submittedIcon } from '../../../constants/icons';
import { getActivities, getApprenticeshipActivities } from '../../../../api/afterLogin/activity';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { format, parse } from 'date-fns';
import NoItems from '../courses/NoItems';

export default function MyActivities({eportfolioAuthToken}) {
  const [activities, setActivities] = useState([]);
  const configData = useSelector((state) => state.config);
  const adminData = useSelector((state) => state.admin);
  useEffect(() => {
    getActivitiesData();
  }, [configData.active_sp_enrollment]);
  const dateConvert = (dateTime) => {
    const parsedDate = parse(dateTime, 'yyyy-MM-dd HH:mm:ss', new Date());
    return format(parsedDate, "MMM d, yyyy");
  };
  const timeConvert = (dateTime) => {
    const parsedDate = parse(dateTime, 'yyyy-MM-dd HH:mm:ss', new Date());
    return format(parsedDate, "h:mm a");
  };
  const getActivitiesData = async() => {
    if(configData.active_sp_enrollment === 'course') {
      const payload = {
        accessToken: configData.access_token,
        userId: configData.session.id,
        userTimeZone: configData.session.us_timezone !== null ? configData.session.us_timezone : ''
      };
  
      try {
        let activities = await getActivities(payload);
        const updatedActivities = activities.map(item => ({
          ...item,
            icon: item.bgClass === "bg-completed" ? certificateIcon : 
                  item.bgClass === "bg-live" ? liveIcon : 
                  item.bgClass === "bg-started" ? menuBookIcon : certificateIcon,
            date: dateConvert(item.created_date),
            time: timeConvert(item.created_date)  
        }));
        setActivities(updatedActivities);
      } catch (err) {
        console.error(err);
      }
    } else if(configData.active_sp_enrollment === 'apprenticeship'){
      const products = adminData.products ?? [];
      let activities = await getApprenticeshipActivities(configData.user_uuid, products, eportfolioAuthToken);
      if(activities && activities.length > 0) {
        const updatedActivities = activities.map(item => ({
          ...item,
          icon: item.status === "Started" ? menuBookIcon : certificateIcon,
          date: item.date ? new Date(item.date).getFullYear()+String(new Date(item.date).getMonth() + 1).padStart(2, "0") + "-" +String(new Date(item.date).getDate()).padStart(2, "0") : '',
          time: item.date ?  String(new Date(item.date).getHours()).padStart(2, "0") + ":" +String(new Date(item.date).getMinutes()).padStart(2, "0") + ":" +String(new Date(item.date).getSeconds()).padStart(2, "0") : '',
          activity: item.title
        }));
        setActivities(updatedActivities);
      }else {
        setActivities([]);
      }
    } else{
      setActivities([]);
    }
    
  }
  return (
    <div className="activities-content">
      {
        activities.length > 0 
        ?
        <ul className="activity-content-list">
          {activities.map((activity, index) => (
            <li key={index}>
              <div className={`icon-wrap ${activity.bgClass}`}>{activity.icon}</div>
              <div className="info-wrap">
                <h4>
                  <span>{activity.status ? activity.status+' ' : ''}{activity.activity}</span>
                </h4>
                <div className="date-wrap">
                  {deadlineIcon}
                  <span>{activity.date}</span>
                  <span className="dot"></span>
                  <span>{activity.time}</span>
                </div>
              </div>
            </li>
          ))}
        </ul> 
        : 
        <NoItems
          className="myk_stu-empty-block w-100 px-3"
          title="No Activities!"
          description="You have no activities yet. Once activities are available, it will show up here."
        />
      }
      
    </div>
  );
}
